import { useCallback } from 'react';
import FJBrushCard from './FJBrushCard';
import { useSelector } from 'react-redux';
import FJActionBrushEditCommon from '../../../redux/action/FJActionBrushEditCommon';
import { useDispatch } from 'react-redux';
import FJUtil from '../../../util/FJUtil';
import PropTypes from 'prop-types';
import useLocalStore from '../../../hooks/useLocalStore';
import { memo } from 'react';

const FJBrushCardContainer = memo(function FJBrushCardContainer(props) {
    useLocalStore();
    const { title, isShowSwitch, changeActive, active, eraseTipsBoxStyle, isShowVideoTips, disabled } = props;
    const dispatch = useDispatch();
    const taskStatus = useSelector(state => state.common.taskStatus);
    const curBrushType = useSelector(state => state.brushEditCommon.curBrushType);
    const isMouseMove = useSelector(state => state.brushEditCommon.isMouseMove);
    const brashSize = useSelector(state => state.brushEditCommon.brushSize);
    const isSlideCompare = useSelector(state => state.brushEditCommon.isSlideCompare);

    const isDisabled = FJUtil.isGeneratingStatus(taskStatus) || disabled;

    const setBrushSize = useCallback(
        (value, type = 'input') => {
            if (isDisabled) return;

            dispatch(FJActionBrushEditCommon.updateBrushSizeAction(Math.round(value), type));
        },
        [dispatch, isDisabled],
    );

    const changeBrushType = useCallback(
        value => {
            if (isDisabled) return;
            dispatch(FJActionBrushEditCommon.setCurBrushTypeAction(value));
        },
        [dispatch, isDisabled],
    );

    const _changeActive = useCallback(
        value => {
            changeActive && changeActive(value);
        },
        [changeActive, isDisabled],
    );

    return (
        <FJBrushCard
            title={title}
            disabled={isDisabled}
            active={active}
            isShowSwitch={isShowSwitch}
            isShowVideoTips={isShowVideoTips}
            brashSize={brashSize}
            eraseTipsBoxStyle={eraseTipsBoxStyle}
            curBrushType={curBrushType}
            isMouseMove={isMouseMove}
            isSlideCompare={isSlideCompare}
            changeBrushType={changeBrushType}
            changeBrashSize={setBrushSize}
            changeActive={_changeActive}
        />
    );
});

FJBrushCardContainer.propTypes = {
    title: PropTypes.string,
    isShowSwitch: PropTypes.bool,
    active: PropTypes.bool,
    changeActive: PropTypes.func,
    eraseTipsBoxStyle: PropTypes.object,
    isShowVideoTips: PropTypes.bool,
};

export default FJBrushCardContainer;
